import { buildMemoSuggestionText } from '../prompts';

export function buildMockReply(mode, text) {
  if (mode === 'anti') {
    return `⚔️ その考えは非常に興味深いですが、あえて「懸念点」を挙げるとすれば何でしょうか？

例えば「${text.slice(0, 40)}...」というアプローチにおいて、もし前提が崩れた場合のリスクはどう評価されていますか？多角的に検討することで、より堅牢な思考に磨き上げましょう。`;
  }

  if (mode === 'input') {
    return buildMemoSuggestionText([], text);
  }

  return `🤖 素晴らしい視点ですね！「${text.slice(0, 40)}...」というお話について、もう少し深掘りしてみませんか？

それを進める上で、今一番ワクワクしているポイントや、逆にまだ言葉にできていない「予感」のようなものはありますか？リラックスして思考を広げていきましょう。`;
}

export function buildMockSummary(messages, memoHint) {
  const isUserMessage = (message) => (message.source ?? message.role) !== 'assistant';
  const userTexts = messages.filter(isUserMessage).map((message) => message.body ?? message.text ?? '');
  const title = memoHint || userTexts[0]?.slice(0, 32) || 'デモメモ';

  return `# ${title}

## 概要

このデモでは、チャットのRawログをあとから読めるNoteへ変換する流れを表現しています。

## ユーザー発言から残すべき情報

${userTexts.map((text) => `- ${text}`).join('\n') || '- まだユーザー発言はありません。'}

## 次にできること

- Note詳細から「Hint抽出」を押してHint候補を作る
- Assets画面で候補を確認する
- 妥当な候補をAsset化する`;
}

export function buildMockInsightCandidates(note) {
  return [
    {
      title: `${note.title || 'このメモ'}から見える判断基準`,
      summary: '会話中に整理しきるより、まず情報を落とさず保存し、後段で構造化することを重視している。',
      type: 'implicit_knowledge',
      suggestedTargetType: 'stance',
      confidence: 0.78,
      tags: note.tags || [],
    },
    {
      title: '再利用できるメモ運用の型',
      summary: 'Rawログ、Note、Hint、Assetを分けることで、未整理情報と採用済み知識の混在を避けられる。',
      type: 'synthesis_suggestion',
      suggestedTargetType: 'framework',
      confidence: 0.74,
      tags: note.tags || [],
    },
  ];
}

export function buildMockHealthProposals(notes, concepts) {
  const proposals = [];

  if (notes && notes.length > 0) {
    proposals.push({
      type: 'note_update',
      targetId: notes[0].id,
      title: 'タグ追加の提案',
      summary: 'このNoteにタグが設定されていません。内容から「アイデア」「設計」の追加を提案します。',
      proposedPatch: { tags: ['アイデア', '設計'] },
      confidence: 0.9,
    });
  }

  if (concepts && concepts.length > 0) {
    proposals.push({
      type: 'asset_update',
      targetId: concepts[0].id,
      title: '成熟度の更新提案',
      summary: '関連するNoteが複数追加されています。成熟度を seed から growing へ引き上げることを提案します。',
      proposedPatch: { maturity: 'growing' },
      confidence: 0.85,
    });
  }

  return proposals;
}
